<template>
  <svg
    width="20"
    height="14"
    viewBox="0 0 20 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0.674316C12.3649 1.7978 14 4.20812 14 7.00049C14 9.79271 12.3647
      12.2021 10 13.3257C7.6353 12.2021 6 9.79271 6 7.00049C6 4.20812 7.63509 1.7978 10 0.674316Z"
      :fill="fillCom"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 0C16.866 0 20 3.13401 20 7C20 10.866 16.866 14 13 14C11.9262 14
      10.9094 13.7578 10 13.3257C9.09063 13.7578 8.07378 14 7 14C3.13401 14 0
      10.866 0 7C0 3.13401 3.13401 0 7 0C8.07363 0 9.09072 0.242354 10 0.674316C10.9093
      0.242354 11.9264 0 13 0ZM7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C7.67066
      13 8.3148 12.8876 8.91699 12.6846C7.15092 11.4138 6 9.34234 6 7.00049C6 4.65843 7.15065
      2.58517 8.91699 1.31445C8.31489 1.11152 7.67055 1 7 1ZM13 1C12.3291 1 11.6844 1.11133
      11.082 1.31445C12.8487 2.58513 14 4.65815 14 7.00049C14 9.34262 12.8485 11.4139 11.082
      12.6846C11.6845 12.8878 12.329 13 13 13C16.3137 13 19 10.3137 19 7C19 3.68629 16.3137
      1 13 1ZM10 1.80371C8.20684 2.8412 7 4.77934 7 7C7 9.22049 8.20707 11.1578 10
      12.1953C11.7929 11.1578 13 9.22049 13 7C13 4.77934 11.7932 2.8412 10 1.80371Z"
      :fill="strokeCom"
    />
  </svg>
</template>
<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  active: {
    type: Boolean,
    default: false
  }
});

const fillCom = computed(() => {
  return props.active ? "#4EAFFF" : "#909AB3";
});
const strokeCom = computed(() => {
  return props.active ? "#1F9AFF" : "#7B87A5";
});
</script>